import posthog from "posthog-js/dist/module.full.js";

let initialized = false;

function posthogHost(): string {
  const raw = import.meta.env.VITE_POSTHOG_HOST || "eu.i.posthog.com";
  if (raw.startsWith("http://") || raw.startsWith("https://")) {
    return raw;
  }
  return `https://${raw}`;
}

export function initPostHog(): void {
  if (!import.meta.env.PROD) return;
  if (initialized) return;

  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key) {
    console.error("Missing VITE_POSTHOG_KEY");
    return;
  }

  if (typeof posthog === "undefined" || !posthog) return;

  posthog.init(key, {
    api_host: posthogHost(),
    autocapture: true,
    disable_session_recording: true,
  });

  initialized = true;
}

export function identifyUser(userId: string): void {
  if (!import.meta.env.PROD || !initialized) return;
  posthog.identify(userId);
}

export function trackEvent(name: string, props?: object): void {
  if (!import.meta.env.PROD || !initialized) return;
  posthog.capture(name, props);
}
